// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".react-datepicker-wrapper {\n  width: 100%;\n}\n\n.dropdown-container[aria-disabled=true] {\n  background: #eff2f5;\n}", "",{"version":3,"sources":["webpack://./src/styles/reset-datepicker.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAGA;EACE,mBAAA;AAAF","sourcesContent":[".react-datepicker-wrapper {\n  width: 100%;\n}\n\n\n.dropdown-container[aria-disabled=true]{\n  background: #eff2f5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
